"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTransactionWithTransfersNftTransfersToJSON = exports.AddressTransactionWithTransfersNftTransfersFromJSONTyped = exports.AddressTransactionWithTransfersNftTransfersFromJSON = void 0;
const runtime_1 = require("../runtime");
function AddressTransactionWithTransfersNftTransfersFromJSON(json) {
    return AddressTransactionWithTransfersNftTransfersFromJSONTyped(json, false);
}
exports.AddressTransactionWithTransfersNftTransfersFromJSON = AddressTransactionWithTransfersNftTransfersFromJSON;
function AddressTransactionWithTransfersNftTransfersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asset_identifier': json['asset_identifier'],
        'value': json['value'],
        'sender': !runtime_1.exists(json, 'sender') ? undefined : json['sender'],
        'recipient': !runtime_1.exists(json, 'recipient') ? undefined : json['recipient'],
    };
}
exports.AddressTransactionWithTransfersNftTransfersFromJSONTyped = AddressTransactionWithTransfersNftTransfersFromJSONTyped;
function AddressTransactionWithTransfersNftTransfersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_identifier': value.asset_identifier,
        'value': value.value,
        'sender': value.sender,
        'recipient': value.recipient,
    };
}
exports.AddressTransactionWithTransfersNftTransfersToJSON = AddressTransactionWithTransfersNftTransfersToJSON;
//# sourceMappingURL=AddressTransactionWithTransfersNftTransfers.js.map